import React from 'react'

export function ImandraLogo(props: React.SVGProps<SVGSVGElement>) {
  const uid = React.useId().replace(/:/g, '')
  const gid = (n: number) => `paint${n}_${uid}`
  return (
    <svg
      {...props}
      viewBox="0 0 222 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M108.227 4.74512H111.384V18.2176H108.227V4.74512Z"
        fill="#00C6CF"
      />
      <path
        d="M129.059 4.74512H131.889V18.2176H128.751V9.78766L124.787 14.6377H124.171L120.167 9.76841V18.2176H117.03V4.74512H119.86L124.459 10.4805L129.059 4.74512Z"
        fill="#00C6CF"
      />
      <path
        d="M147.917 18.2176L146.917 15.7925H140.277L139.276 18.2176H135.908L141.951 4.74512H145.319L151.324 18.2176H147.917ZM143.626 7.76679L141.412 13.0788H145.8L143.626 7.76679Z"
        fill="#00C6CF"
      />
      <path
        d="M164.71 4.74512H167.847V18.2176H165.018L158.916 9.88389L158.955 13.5215V18.2176H155.818V4.74512H158.647L164.748 13.1173L164.71 9.51821V4.74512Z"
        fill="#00C6CF"
      />
      <path
        d="M178.997 4.74512C180.383 4.74512 181.595 5.02098 182.635 5.57271C183.687 6.12444 184.495 6.91354 185.06 7.94001C185.637 8.95365 185.926 10.1341 185.926 11.4813C185.926 12.8286 185.637 14.0154 185.06 15.0419C184.495 16.0556 183.687 16.8382 182.635 17.39C181.595 17.9417 180.383 18.2176 178.997 18.2176H173.473V4.74512H178.997ZM178.997 15.4653C180.126 15.4653 181.037 15.1061 181.73 14.3875C182.423 13.669 182.769 12.7003 182.769 11.4813C182.769 10.673 182.609 9.97371 182.288 9.38349C181.98 8.78044 181.537 8.31852 180.96 7.99775C180.396 7.66415 179.741 7.49735 178.997 7.49735H176.63V15.4653H178.997Z"
        fill="#00C6CF"
      />
      <path
        d="M193.928 13.7717H195.756L199.182 18.2176H202.935L199.125 13.5022C200.1 13.1943 200.85 12.6746 201.376 11.9433C201.915 11.2119 202.185 10.333 202.185 9.3065C202.185 8.40834 201.986 7.61282 201.588 6.91996C201.19 6.22709 200.626 5.6946 199.894 5.32251C199.163 4.93758 198.31 4.74512 197.335 4.74512H190.772V7.43961H196.969C197.636 7.43961 198.149 7.60641 198.509 7.94001C198.881 8.27362 199.067 8.74194 199.067 9.345C199.067 9.94805 198.887 10.4164 198.528 10.75C198.169 11.0708 197.649 11.2311 196.969 11.2311H194.769H193.908L193.909 9.73814L190.772 8.66502V18.2176H193.928V13.7717Z"
        fill="#00C6CF"
      />
      <path
        d="M217.806 18.2176L216.805 15.7925H210.165L209.164 18.2176H205.796L211.839 4.74512H215.207L221.212 18.2176H217.806ZM213.514 7.76679L211.3 13.0788H215.689L213.514 7.76679Z"
        fill="#00C6CF"
      />
      <circle cx="11.4223" cy="11.4816" r="10.633" fill={`url(#${gid(0)})`} />
      <path
        d="M40.7703 5.42178C40.7703 2.74805 42.9378 0.580566 45.6115 0.580566C48.2853 0.580566 50.4527 2.74805 50.4527 5.42178V17.5414C50.4527 20.2151 48.2853 22.3826 45.6115 22.3826C42.9378 22.3826 40.7703 20.2151 40.7703 17.5414V5.42178Z"
        fill={`url(#${gid(1)})`}
      />
      <circle cx="79.8007" cy="11.4816" r="10.633" fill={`url(#${gid(2)})`} />
      <defs>
        <linearGradient
          id={gid(0)}
          x1="-4.66413"
          y1="22.1145"
          x2="-5.49676"
          y2="-4.07142"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#001AFF" />
          <stop offset="1" stopColor="#00E0FF" />
        </linearGradient>
        <linearGradient
          id={gid(1)}
          x1="38.2873"
          y1="22.3826"
          x2="36.3731"
          y2="-4.35361"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#001AFF" />
          <stop offset="1" stopColor="#00E0FF" />
        </linearGradient>
        <linearGradient
          id={gid(2)}
          x1="63.7142"
          y1="22.1145"
          x2="62.8816"
          y2="-4.07142"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#001AFF" />
          <stop offset="1" stopColor="#00E0FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
